module.exports = __webpack_public_path__ + "img/1.64bc5275.jpg";